import React, { useState } from 'react'
import { ThemeProvider as SCThemeProvider } from 'styled-components'
import { light as lightBase, dark as darkBase, PancakeTheme } from 'polyquail-uikit'

const CACHE_KEY = 'IS_DARK'

const ThemeContext = React.createContext({ isDark: null, toggleTheme: () => null })

const ThemeContextProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    const isDarkUserSetting = localStorage.getItem(CACHE_KEY)
    return isDarkUserSetting ? JSON.parse(isDarkUserSetting) : false
  })

  const toggleTheme = () => {
    setIsDark((prevState) => {
      localStorage.setItem(CACHE_KEY, JSON.stringify(!prevState))
      return !prevState
    })
  }

  // customize colors

  const light: PancakeTheme = lightBase

  light.colors.primary = '#ff9100'
  light.colors.primaryBright = '#ff9100'
  light.colors.primaryDark = '#ff9100'
  light.colors.secondary = '#7DCEA8'
  light.colors.background = '#F5F6FA'
  light.colors.success = '#E84970'

  light.colors.text = '#28033D'
  light.colors.textSubtle = '#28033D'

  light.button.primary.background = '#ff9100'
  light.button.primary.backgroundActive = '#ff9100'
  light.button.primary.backgroundHover = '#ff9100'

  // console.log(light)

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      <SCThemeProvider theme={isDark ? darkBase : light}>{children}</SCThemeProvider>
    </ThemeContext.Provider>
  )
}

export { ThemeContext, ThemeContextProvider }
